import { render, staticRenderFns } from "./SV.vue?vue&type=template&id=6b24c960&"
import script from "./SV.vue?vue&type=script&lang=js&"
export * from "./SV.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b24c960')) {
      api.createRecord('6b24c960', component.options)
    } else {
      api.reload('6b24c960', component.options)
    }
    module.hot.accept("./SV.vue?vue&type=template&id=6b24c960&", function () {
      api.rerender('6b24c960', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/customDocuments/vistas/empresas/61808000-5/SV.vue"
export default component.exports